module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ChangePassword", "Change account password") ))==null?'':__t)+
'</legend><div><label for="password-old-input">'+
((__t=( i18n.tc("ChangePassword", "Old password:") ))==null?'':__t)+
'</label> <input type="password" id="password-old-input" data-input="password-old" '+
((__t=( oldPassRequired ))==null?'':__t)+
'></div><div><label for="password-new-1-input">'+
((__t=( i18n.tc("ChangePassword", "New password:") ))==null?'':__t)+
'</label> <input type="password" id="password-new-1-input" data-input="password-new-1" required></div><div><label for="password-new-2-input">'+
((__t=( i18n.tc("ChangePassword", "Repeat new password:") ))==null?'':__t)+
'</label> <input type="password" id="password-new-2-input" data-input="password-new-2" required></div></fieldset><fieldset class="button-wrap"><button data-click="password-cancel">'+
((__t=( i18n.tc("ChangePassword", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="password-submit" disabled="disabled">'+
((__t=( i18n.tc("ChangePassword", "Change") ))==null?'':__t)+
'</button> <button class="primary" data-click="password-close" hidden>'+
((__t=( i18n.tc("ChangePassword", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
